'use client'
import {Modal} from 'antd'
import React, {useState} from "react";
import classes from "./Popup.module.scss"
import Image from 'next/image'
import {useTranslation} from "react-i18next";
import playIcon from '../../assets/images/icons/playIcon.svg';

function Popup({children, buttonText, closeIcon, video = false}) {
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const closeModal = () => {
        setIsOpen(false);
        // stop video
        if (video) {
            if (document.getElementById('video')) {
                document.getElementById('video').setAttribute('src', '');
            }
        }
    }

    const openModal = () => {
        setIsOpen(true);
        // play video
        if (video) {
            if (document.getElementById('video')) {
                document.getElementById('video').setAttribute('src', 'https://www.youtube.com/embed/ZO0zkwLBJl8?si=w3XMkuFY-xQwWOYJ&autoplay=true');
            }
        }
    }

    const childrenWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {closeModal});
        }
        return child;
    });

    return (<>
            {video ? <span onClick={() => openModal()} className={classes.videoLink}><Image src={playIcon}
                                                                                            alt={'play-icon'}/>
                    <span>{buttonText}</span>
            </span> : <button onClick={() => openModal()}>{buttonText}</button>}
            <Modal
                className={classes.modal}
                closeIcon={<span onClick={() => closeModal()}><Image src={closeIcon} alt='closeIcon'/></span>}
                footer={[]}
                onCancel={() => closeModal()}
                open={isOpen}>
                {childrenWithProps}
            </Modal>
        </>);
}

export default Popup;